import axios  	from 'axios'
import EventBus from '@/event-bus'
import Start 	from '@/class/start'
import Shape 	from '@/class/shapes'
import list_dev from '@/components/tester/jsons/list_devices_test.json'
import cam_test from '@/components/cam_test.vue'
import Draw 	from '@/class/drawer'
export default{
	name 		: 'zone',
	components  : {
		cam_test
	}, // components
	props 		: [
		'info_to_constellation',
		'info_to_component',
		'layout_id',		
		'is_edit',
		'layout_end',
		'selected_type',
		'actions_component',
		'notShowBar',
		'selectionZoneByAlert',
	],
	data 		: (vm) => ({
		info : {
			name : 'title',	
			id 	 : null,
			devices : []			
		},
		title 			  : vm.$ml.get('zone'),
		dialog 			  : false,
		list 			  : [],
		showMenu 		  : false,
		info_alerts 	  : [],
		list_device 	  : [],
		list_selected 	  : [],
		sel_constellation : '',
		context_draw 	  : null,
		show 			  : {
			bar   	  : true, 
			close 	  : true,
			analytics : false,
			redirect  : true,
			// select_zone : false, 
		}, 
		// container_draw : null, 
		positions: { 
			x : 0, 
			y : 0,
			max_width  : 300,
			max_height : 150, 
		},
		coordinates   : [],
		shape_draw    : {},
		shape 		  : null,
		list_analytic : [ 
			{
				text : 'Objects',
				key  : 'objects',					
			},
			{
				text : 'Motion',
				key  : 'motion',					
			},
		],
		list_shapes : [
			{
				text : 'normal',
				key  : 'normal',					
			},
			{
				text : 'success',
				key  : 'success',					
			},
			{
				text : 'warning',
				key  : 'warning',					
			},
			{
				text : 'alert',
				key  : 'alert',					
			}
		],
		sel_shape  	  : 'normal',
		start 		  : null,
		ref_draw 	  : '',
		device_stream : { 
			deviceId : '',
			name   : ''
		},
		canvas    		 : null,
		image 	  		 : null,
		content   		 : null,
		event_bus 		 : null,
		list_draws 		 : [],
		image_background : vm.$EXT + '/img/zones/image_default.png',
		image_const_bg   : vm.$EXT + '/img/constellation.jpg',
		drawer 			 : null, // class manager drawer
		bus 			 : {},
		item 			: {},
		dialogDelete 	: false,
		headers: [
			{ text: 'Name', 		value: 'name' },
			{ text: 'Description',  value: 'description' },
			{ text: 'Image', 		value: 'image_url' },
			{ text: 'Actions', 		value: 'action', sortable: false },
		],
		desserts: [],
		editedIndex: -1,
		editedItem: {
			name: '',
			description: '',
			image: '',
			image_url: '',
		},
		defaultItem: {
			name: '',
			description: '',
			image: '',
			image_url: '',
		},
		objectURLs: {},
		streamingObjectURL: null,
	}), // data

	

	created(){
		// get list constellations
		//console.log(this.ref_draw, this.layout_id, this.info_to_constellation, '********************************************** created')
		this.ref_draw = this.layout_id;

		if (this.info_to_constellation) {
			this.info  = this.info_to_constellation;
			this.title = this.info_to_constellation.name;
		}

		if (!this.ref_draw) {
			if (this.info) {
				this.ref_draw = 'zone' + this.info.name;
			}else{					
				this.ref_draw = 'zone';					
			}
		}
		if (this.$route.name == 'settings_zones') {
			this.show.bar = false;
		}else
		if (this.notShowBar) {
			this.show.bar = false;
		}
		if (!this.$Helper.current_auth_user(this.currentUser, {roles : [1, 2]})) {
  			this.show.close 	= false;
  			this.show.redirect 	= false;	

  		}
		this.get_list();
		// console.log("Zone by alert ", this.selectionZoneByAlert);

		if (this.selectionZoneByAlert) {				
			this.$nextTick(()=>{
				this.selected_constellation(this.selectionZoneByAlert);
			})
		}
	}, // created

	watch:{
		layout_end: function(val){
			if (val) {
				//console.log('resize')					
				this.onResize();
			}
		},// layout

		dialog: function(val){
			if (!val){
				this.close_cam();
			}
		}, // dialog
		
		info_to_component : {
			handler(val){

				//console.log(" check new val info comp draw shape polygon", val);
				if (val && this.is_edit && val.type_zone) {  //this.selected_type
					if (this.list_draws && this.list_draws.length > 0) {
						//console.log(" check new val update shape polygon");
						this.render_draws('polygon',this.info_to_component, 'update');


					}else{
						if (val && val.device && val.device.length > 0) {
							//console.log(" check new val create shape polygon");
							this.render_draws('polygon',this.info_to_component, 'create');							
						}else{
							if (val.type_zone) {
								let img 	= document.getElementById('image' + this.ref_draw);
								
								if (val.url_image) {
									img.src = this.$URL + val.url_image;

								}else{
									img.src = this.image_background;
								}

							}
						}

					}

				}else if(val && !val.type_zone){
					let img	= document.getElementById('image' + this.ref_draw);
					img.src = this.image_const_bg;

				}
			}, deep: true
		}, // info to component

		actions_component: function(val){
			// console.log("render_points in zones")

			if (val == 'save' || val == 'update' || val == 'test') {
				this.$emit('receive_info', this.list_draws);
			}
		}, // actions component

		selectionZoneByAlert: function(val){
			// console.log("Zone by alert ", val);
			if (val) {
				this.$nextTick(()=>{
					this.selected_constellation(val);
				})
			}
		}
	}, //watch

	computed:{
		list_render: function(){
			return this.list;
		}, // list render

		renderListDraws: function(){
			return this.list_draws;
		},

		currentUser(){
  			return this.$store.state.auth.user;
		}, // currentUser
	}, // computed

	methods : {
		actions(act, item){
			
		}, 
		/*get_constellation(){
			let info_get 	= this.info;
			const api 		= this.$URL + '/api/v1/constellation/' + info_get.id;
			this.$axios.get(api).then( res => {
				this.list = res.data.rows;				
			}).catch( er => {				
			});
		},*/
		selected_constellation(item){			
			// console.log("selected_constellation ", item)
			let vl 		 = this;
			let search 	 = null;
			let info_set = null;
			search 		= item.id;
			
			const find 	= vl.list.some((arr_list, idx_list)=>{
				if (search == arr_list.id) {						
					info_set = arr_list; 
					return true
				}
			})
			
			if (this.layout_id && 
				info_set && 
				info_set.name !== this.title) {

				let id = this.layout_id;

				this.$emit('add_layout', { 
					"layout_id" : id, 
					info 		: item,
				});
			}
			// console.log("find zone ", find)
			if (!find) {
				
				this.title 		= this.$ml.get('zone');
				this.info.name 	= '';
				this.info.id 	= this.layout_id;
			}else{					
				this.info = info_set;
				this.title = info_set.name;
				if (info_set && info_set.device) {		

					if (this.drawer && this.list_draws && this.list_draws.length > 0) {
						let draw = this.drawer;
						let vm   = this;
						vm.list_draws.forEach((dr)=>{
							
							let temp_list = draw.delete_list_shape('polygon', dr);
							if (temp_list && temp_list.length >= 0) {
								vm.list_draws = temp_list;
								if (temp_list.length === 0) {
									vm.list_draws = [];
								}
							}
						})
					}							
					this.coordinates = [];
					// console.log("type zone ", info_set)
					if (info_set.type_zone) { 
						this.render_draws('polygon', info_set, 'create');
					}else{
						EventBus.$emit('start_constellation', info_set);
						this.$nextTick( () =>{
							this.start = null;
							this.render_devices(info_set)
						})
					}			
				}
			}
		}, // selected devices

	
		update(){
			const info_up 	= this.info;
			let list_temp 	= [];
			let vn 			= this;			
			const api 		= this.$URL + '/';
			const finded = vn.list.some((arr_list, idx_list)=>{
				if (arr_list.id == info_up.id) {
					vn.list[idx_list] = info_up;
					return true
				}
			})
			if (finded) {
				list_temp = JSON.stringify([...this.list]);
				localStorage.setItem('constellations', list_temp);
				EventBus.$emit('notifications_modal', { type: 'updated' });
			}
		}, // update

		redirect(){
			let type = this.info
			localStorage.setItem('constellation_redirect', JSON.stringify(type));
			if (this.$route.name !== 'settings_zones') {
				this.$router.push({ name: 'settings_zones' }).catch(err => {
					if (err.name !== 'NavigationDuplicated') throw err;
				});
			}
		}, // redirect

		

		render_devices(devs){			
			let list_temp 	= devs.device;
			let rd 			= this;
			let sw 			= false;

			if (list_temp && list_temp.length > 0){
				let temp_y 	= 5;//idx_dev;
				let temp_x 	= 0; 
				let aux		= 0;


				// this.onResize();


				list_temp.forEach( function (arr_dev, idx_dev){
					if (arr_dev && arr_dev.posX && arr_dev.posY ){
						temp_x = arr_dev.posX;
						temp_y = arr_dev.posY
						//rd.draw_shapes('normal', temp_x, temp_y);
					}else{
						temp_x = 25/*60*/ * aux;
						if (temp_x >= 300) {

							aux = 0;

							temp_y = temp_y + 30;
							temp_x = temp_x * aux;
						}
						
						temp_x += 10;
						
						
						//rd.draw_shapes( 'normal', temp_x, temp_y);
						
						list_temp.posX = temp_x;
							list_temp.posY = temp_y;

						aux++;
					}
					rd.coordinates.push({
						device : arr_dev.deviceId,
						posX   : temp_x,
						posY   : temp_y, 

					});

				}); // forEach

				this.info.device = list_temp;
				if (sw) {
					this.update();
				}
				//console.log('clear canvas : ', this.shape_draw)
				// this.onResize();
				
				// this.context_draw.clearRect(0, 0, this.shape_draw.w, this.shape_draw.h );
				this.onResize();
				

			}

		}, 

		/*
			Rombo 			=  	gris , Gray, normal	= Diamond
			Circulo Verde 	= 	aceptado, success	= Green circle
			Triangulo 		= 	warning, 			= Triangle
			Circulo rojo 	= 	alert, 				= Red circle
		*/

		onResize(){

			// console.log('Start  resize')
			let n = 0,
				grad,
				r,
				decimal,
				nm = 0;

			;
			let { w , h } = this.render_resize(); //this.shape_draw;

			

			// this.context_draw.clearRect(0, 0, w, h);
			// this.context_draw.strokeStyle = "grey";
			// this.context_draw.lineWidth = 0.1;

			//console.log(' onresize: width : ',w, ' \n height :',h);


			if (this.coordinates && this.coordinates.length > 0) {
				n = this.coordinates.length;
			
			this.$nextTick(() => {



				r = Math.sqrt(n);				
				
				decimal = (r+"").split(".")[1];
				nm 		= (r+"").split(".")[0]
				
				if ( decimal > 0 ) {
					nm ++; 
				}

				// console.log('raiz', r, "\n decimal : ", decimal, 'Matrix x ', nm);

				let	bx = 0, // pos X
					by = 0, // pos Y
					bw = 0, // width
					bh = 0, // height
					file = 0, 
					column = 0,
					sw = 0,
					sh = 0;

				sw = w / nm;
				sh = h / nm;
				bw = sw;
				bh = sh;

				// console.log(n , 'N elementos    W :', w, ' H : ', h)
				let  control_device = 0;
				while (file < nm){
					while (column < nm){
						// console.log(control_device)
						if (this.info.device[control_device]){
							// console.log(this.info.devices[control_device])
							if (this.coordinates[control_device].start) {
								this.coordinates[control_device].start.resize(bx, by, bw, bh);
								this.coordinates[control_device].start.drawToCanvas(this.context_draw);
							}else{

								this.coordinates[control_device].start = new  Start(bx, by, bw, bh,this.info.device[control_device],this.info,EventBus);
								this.coordinates[control_device].start.drawToCanvas(this.context_draw);
							}
							
							if (this.info.device[control_device].deviceId == this.coordinates[control_device].device) {
								this.coordinates[control_device].posX  = bx;
								this.coordinates[control_device].posY  = by;
								this.coordinates[control_device].width  = bw;
								this.coordinates[control_device].height = bh;
								this.coordinates[control_device].name 	= this.info.device[control_device].name;
							}
							control_device++;
						}

						//this.start.setEventBus(EventBus);

					
						/*console.log( 
							`
							punto X: ${bx}, 
							punto Y: ${by}, 
							tamaño W:  ${bw}, 
							tamaño H:  ${bh},
							suma de Y => : ${by + sh},
							Matrix : [ ${file}, ${column}  ]`);*/
							// setTimeout(()=>{

							// this.shape = new Shape(	bx, 
							// 						by, 
							// 						parseInt(bw), 
							// 						parseInt(bh));
							
							// this.shape.addShappe(this.context_draw, 'success');
							
						
						bx = bx + sw;
						column++;

					} //  while column
					bx 		= 0;
					by 		= by + bh; 
					column 	= 0;
					file++;

				} // while f

				this.$emit('resized_state', false);
			})
			}
		}, // onResize

		render_resize(){ // clear && get widht and height
			let content 		= document.getElementById('content' + this.ref_draw);			
			// image background
			let img 			= document.getElementById('image' + this.ref_draw);
			// canvas
			let board 			= document.getElementById('draw' + this.ref_draw);

			let width = 	board.width  =  img.getBoundingClientRect().width;
			let height = 	board.height =  img.getBoundingClientRect().height;
			if (board.getContext("2d")) {

				this.context_draw = board.getContext("2d");
				
				this.context_draw.clearRect(0,0, width, height);
				this.shape_draw={
					w: width,
					h: height
				};
				let w = width,
					h = height;
				return {w , h}
			}
			return { w : null , h : null	}
			// console.log(width, height);

		}, // render resize

		render_draws(shape, item, opt = 'create'){
			// console.log("RENDER DRAW *********** ", shape, item, opt)
			if (item) {
				let vm = this;
				// container
				let content = document.getElementById('content' + this.ref_draw);
				// this.content_draw 	= content;					
				let img 	= document.getElementById('image' + this.ref_draw);					

				let is_drawing = this.$route.name != 'settings_zones' ? false : true; 

				if (item.url_image) {
					img.src = this.$URL + item.url_image;
				}else{
					if (item.type_zone) {
						img.src = this.image_background;
					}else{
						img.src = this.image_const_bg;
					}
				}
				if (shape == 'polygon') {
					let list 		= item.device;
					let list_points = item.devices_points; 					
					// console.log("polygon", item);
					if (list && list.length >= 0 ) {
						
						if (opt == 'create') {		
							this.createDraw({
								item,
								list,
								is_drawing,
							});
						} // create
						if (opt == 'update') {
							this.updateDraw({
								item,
								list,
								is_drawing,
							})
						} // update

					}
				}
			}
		}, // render draws

		createDraw({item, list, is_drawing}){
			// console.log('create zone', is_drawing);
			let {bx, by, bw, bh, w, h} 	= this.render_coord(list.length);
			let draw 					= null;
			
			let points 		= [];
			let vm 			= this;
			let option_draw = 'other';
			if (item.points) {
				try{										
					points = JSON.parse(item.points);
				}catch(er){
					console.log("not cant convert json to object zone : ", er);
				}
				option_draw = 'coords';
			}

			vm.list_draws	= [];						
			

			list.forEach((r)=>{								
				vm.list_draws.push({
					deviceId : r.deviceId,
					name 	 : r.name
				});								
			});
			const timer = setTimeout(()=>{
				list.forEach((dev, idx_dev, len_dev) => {
					let info_up = {
						deviceId : dev.deviceId,
						name 	 : dev.name,									
					};
					let draw_canv 		= 'draws' + vm.ref_draw + idx_dev + vm.layout_id;
					let check_construct = null;
					if (!draw) {

						draw  = new Draw(
							'content' + vm.ref_draw, 
							'image'   + vm.ref_draw, 
							draw_canv, 
							'polygon',
							info_up,
							is_drawing,
							);
						check_construct = true;
						if (item.icon_color) {

							draw.set_color_tags(item.icon_color);
						}
					}else{
						check_construct = draw.contruct_draw(draw_canv ,'polygon' , info_up);
					}
					// console.log(bx, by, bw, bh, w, h)
					// console.log("POINTS ==== ", idx_dev, points )
					draw.setTextList(idx_dev, points[idx_dev].name);
					if (check_construct) {
						if (is_drawing) {
							
							let temp_point = points &&  points.length > 0 && points[idx_dev] && points[idx_dev].points ?  
								points[idx_dev].points : null;							
							draw.draw_shape(
								option_draw,
								idx_dev, 
								null, 
								temp_point, 
								bx, by, bw, bh
							);
							// draw.set_text(dev.name);
							bx = bx + bw ;
							if (bx >= w) {										
								bx 		= 0;
								by 		= by + bh; 
							}
						}else{
							// draw in dashboard
							// draw.draw_shape(bx, by, bw, bh, idx_dev,'other');
							let temp_point = points[idx_dev].points;	
							draw.draw_shape(
								option_draw,
								idx_dev, 
								null, 
								temp_point
							);
						}
						if (points && points[idx_dev] && points[idx_dev].camPoints) {
							let tempCamPoints = points[idx_dev].camPoints;
							draw.setCamPoint(idx_dev, tempCamPoints);

							// console.log("DRAW CAM ", points[idx_dev].camPoints)
							
							const drawTemp = draw.getListShapeById(idx_dev)
							if (drawTemp) {
								const timer = setTimeout(()=>{
									if (tempCamPoints && tempCamPoints.length > 0 && tempCamPoints[0]) {
										draw.reDrawCamera(drawTemp.context, idx_dev);
									}
									clearTimeout(timer);
								},100)
							}
						}
						draw.set_bus(this.$EventBus);
						draw.open_bus(idx_dev);

						if (idx_dev == len_dev.length - 1) {
							this.$nextTick(()=>{

								vm.list_draws = draw.get_list_shape();
								this.drawer   = draw;
								// console.log("LIST DRAWS ", vm.list_draws)
							})
						}
					}
					// console.log("DRAWER ", this.drawer, this.coordinates)
					clearTimeout(timer);
				}, 100)
			});
		}, // createDraw
		updateDraw({item,list,is_drawing}){
			let {bx, by, bw, bh, w, h} 	= this.render_coord(list.length);
			let draw 					= null;
			let vm 			= this;
			
			draw 	  	  = this.drawer;
			let list_draw = this.list_draws;
			let list_opts = []; 
			
			if (list_draw && list_draw.length > 0) {
				let option    = '';
				let list_Myr = list;
				let list_mnr = list_draw; 
				// reduce
				if (list_draw.length > list.length) {
					option 	 = 'reduce';
					list_Myr = list_draw;
					list_mnr = list;
				}// add
				else{
					option = 'add';								
				}
				// console.log("check len : option : ", option, list, list_draw)
				
				list_Myr.forEach((dev, idx_dev)=>{
					let find = false;
					list_mnr.forEach((dr, id_dr)=>{
						if (dev.deviceId == dr.deviceId) {
							find = true
						}
					})
					
					if (!find) {
						
						list_opts.push(dev);
					}
				}); // list devices selecteds
				// console.log("opts  : ", list_opts)
				if (list_opts && list_opts.length > 0) {
					list_opts.forEach((dr)=>{
					if (option == 'add') {

						let leng = vm.list_draws.length;
						

						vm.list_draws.push({
							deviceId : dr.deviceId,
							name 	 : dr.name,		
						});
						dr.len 	= leng;						
					
					}
					if (option == 'reduce') {
						let temp_list = draw.delete_list_shape('polygon', dr);
						if (temp_list && temp_list.length >= 0) {
							vm.list_draws = temp_list;
							if (temp_list.length === 0) {
								vm.list_draws = [];
							}
						}
					}
					});
					const timer = setTimeout(() => {
						list_opts.forEach((dw, idx_dw, len_dw)=>{
							if (option == 'add') {
								// console.log("Add draw polygon")
									let info_up1 = {
										deviceId : dw.deviceId,
										name 	 : dw.name,		
										 							
									};
									
									let draw_canv   = 'draws' + vm.ref_draw + dw.len + vm.layout_id;
									// console.log(dw.len, draw_canv)
									let check_construct = draw.contruct_draw(draw_canv,
										'polygon', 
										info_up1
										);
									if (check_construct) {

										draw.draw_shape(
											'other',
											dw.len, 
											info_up1,
											null,
											bx, 
											by, 
											bw - 10, 
											bh - 10, 													
											
											
										);
										bx = bx + bw ;
										if (bx >= w) {										
											bx 		= 0;
											by 		= by + bh; 
										}
										if (idx_dw) {
											draw.set_bus(this.$EventBus);
											draw.open_bus(idx_dw);
											vm.list_draws[dw.len] = draw.get_list_shape(idx_dw);
											// console.log("check list complet :", vm.list_draws)
										}
									}
							}
							clearTimeout(timer);
							

						});
					}, 150)

				}

			}else{
				this.render_draws('polygon',this.info_to_component, 'create');
			}
		}, // updateDraw
		render_coord(len){
			let { w , h } = this.render_resize(); //this.shape_draw;
			let	bx = 0, // pos X
				by = 0, // pos Y
				bw = 0, // width
				bh = 0; // height
			if (len > 0) {

				let n = 0,
					grad,
					r,
					decimal,
					nm = 0;

				;
				n = len;
				r = Math.sqrt(n);				
					
				decimal = (r+"").split(".")[1];
				nm 		= (r+"").split(".")[0]
				
				if ( decimal > 0 ) {
					nm ++; 
				}

				// console.log('raiz', r, "\n decimal : ", decimal, 'Matrix x ', nm);

				
				let	file = 0, 
					column = 0,
					sw = 0,
					sh = 0;

				sw = w / nm;
				sh = h / nm;
				bw = sw;
				bh = sh;
			}else{
				console.log("number of item  0 ");
			}
				return {
					bx, by, bw, bh, w , h
				}
		}, // render coord
		mouseDown(event){
			console.log("mousedown ", event)
		},

		select_shape(item){
			this.sel_shape = item;
			let vm = this;
			vm.coordinates.forEach( (arr_shape, idx_shape)=>{
				arr_shape.start.setShape(item, 'grey', 'objects'); 
			})
		}, // select shape

		pointInPolygon(x, y, vertices) {
            let dentro = false;            
            for (let i = 0, j = vertices.length - 1; i < vertices.length; j = i++) {
                const xi = vertices[i][0];
                const yi = vertices[i][1];
                const xj = vertices[j][0];
                const yj = vertices[j][1];
                const intersecta = ((yi > y) !== (yj > y)) &&
                    (x < ((xj - xi) * (y - yi)) / (yj - yi) + xi);              
                if (intersecta) dentro = !dentro;
            }

            return dentro;
        },

		send_action_icon(pos){
			let list_temp = [];
			let vm = this;
			if (this.coordinates && this.coordinates.length > 0 ){
				list_temp = this.coordinates;
				let timer = {};
				let dev = {};
				const finded = list_temp.some(( arr_icon, idx_icon)=>{
					if ( (arr_icon.posX <= pos.x && pos.y >= arr_icon.posY ) && 
						(pos.x <= arr_icon.posX + arr_icon.width && pos.y <= arr_icon.posY + arr_icon.height)) {
						//timer[idx_icon] 
							dev.deviceId = arr_icon.device;
							dev.name 	 = arr_icon.name;
						return true
					}
				})
				if (finded) {
					const timer = setTimeout(()=>{
						vm.device_stream = {...dev }
						vm.dialog = true;
						// vm.streaming();
						clearTimeout(timer);
					},100)
				}
			}else if(this.drawer && this.drawer.list && this.drawer.list.length > 0){				
				let timer = {};
				let dev = {};				
				const finded = this.drawer.list.some((it,idx_icon)=>{					
					if (it && it.polygon) {
						if(this.pointInPolygon(pos.x, pos.y, it.polygon)){
							//timer[idx_icon] 
							dev.deviceId = it.deviceId;
							dev.name 	 = it.name;
							return true;
						}

					}
				})
				if (finded) {

					const timer = setTimeout(()=>{								
						vm.device_stream = {...dev}
						vm.dialog = true;
						// vm.streaming();
						clearTimeout(timer);
					},100)
				}
			}

		}, // send action icon

		close_cam(){
			this.dialog = false;				
			// let temp 	= 'stream' + this.device_stream.device + this.layout_id; 
			// let temp1  	= 'event_stream' + this.device_stream.device + this.layout_id; 
			// EventBus.$off(temp, this.bus[temp]);
			// EventBus.$off(temp1, this.bus[temp1]);

			this.device_stream = null;
		}, // close cam

		streaming(){	
			this.event_bus = this.device_stream.deviceId; 
			this.$nextTick(() =>{
     			let content         =   document.getElementById('content' + 'streaming');
     			// streaming
				let img  			=   document.getElementById('img' + 'streaming');			
		      	// get sizes
		      	let current_width 	= img.getBoundingClientRect().width,  
          		current_height 		= img.getBoundingClientRect().height;
          		
				img.src  	  		= 'img/no_img_found.png';
				// Bus images
				let temp_bus  		= 'stream' + this.device_stream.deviceId + this.layout_id; 
				EventBus.$on(temp_bus, this.bus[temp_bus] = (msg) => {
					if (this.streamingObjectURL) {
						URL.revokeObjectURL(this.streamingObjectURL);
					}
					const blob = this.base64ToBlob(msg, 'image/jpeg');
					this.streamingObjectURL = URL.createObjectURL(blob);
					img.src = this.streamingObjectURL;
		        })
				
				// Bus events
				let temp_bus1 = 'event_stream' + this.stream + this.layout_id;
				EventBus.$on(temp_bus1, this.bus[temp_bus1] = (msg) => {

			        if (msg && msg.analytics_results[0] && msg.analytics_results[0].bbox) {
			          let box = msg.analytics_results[0].bbox;
			          let exs = msg;

			          current_width  = roi.width  = img.getBoundingClientRect().width; 
			          current_height = roi.height = img.getBoundingClientRect().height;


			          let xn = box.x - (box.w/2);
			          let yn = box.y - (box.h/2);


			           context_roi.clearRect(0, 0, current_width, current_height );


			          let factorx = (roi.width / 320);
			          let factory = (roi.height / 240);
			          if (exs.analytics_results){
			               let aux = {};

			            exs.analytics_results.forEach(function (element, index, array) {
			               let o = Math.round, r = Math.random, s = 255;
			               let ca = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ',0.5)';
			               let  num1 =o(r()*s)
			               let num2 =o(r()*s)
			               let num3 =o(r()*s)
			              if (vm.coords_multi){              
			              }
			              context_roi.fillStyle = 'rgba('+num1+','+num2+','+num3+',0.5)';



			             let fx = element.bbox.x *  parseInt(current_width) ;
			              let fy = element.bbox.y *  parseInt(current_height);
			              let w  = element.bbox.w * parseInt(current_width);
			              let h  = element.bbox.h *  parseInt(current_height);			              
			              fx = Math.abs(fx)
			              fy = Math.abs(fy)
			              
			                context_roi.fillRect(fx,fy,w,h);

			              
			              
			              context_roi.font 		= "12px Georgia";
			              context_roi.fillStyle = "rgba(0,0,0,1)";
			              context_roi.fillText(element.tag, fx+20, fy+20)//(element.bbox.x*factorx)+20, (element.bbox.y*factory)+20);
			              aux = {
			                x : fx * parseInt(current_width),
			                y : fy * parseInt(current_height),
			                w : element.bbox.w * parseInt(current_width),
			                h : element.bbox.h* parseInt(current_height)
			              }

                    
			        });
			        }
			      
			      }
			    })	
		    })
		}, // streaming

		get_list(){			
			if (this.$Constellations && this.$Constellations.length > 0) {
				this.list = this.$Constellations;
			}			
			if (this.list && this.list.length == 0) {		
				if (localStorage.getItem('constellations')) {
					this.list = JSON.parse(localStorage.getItem('constellations'));
					// console.log(this.list, 'list get 2')
				}else{
					// console.log(this.list, 'list get 3')
					this.get_constellation();
				}
			}			
		},

		get_constellation(){
			let info_get = this.info;
			const api 	 = this.$URL + '/api/v1/constellation/';
			this.$axios.get(api).then( res => {				
				if (res && res.data && res.data.rows && res.data.rows.length > 0){
					this.list = res.data.rows;				
				}else{
					console.warn("info Zones no found ");
				}				
			}).catch( er => {
				console.log(er, 'Error get constellation');
			});
		}, // get Constellation

		base64ToBlob(base64, contentType) {
			const byteCharacters = atob(base64);
			const byteNumbers = new Array(byteCharacters.length);
			for (let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i);
			}
			const byteArray = new Uint8Array(byteNumbers);
			return new Blob([byteArray], { type: contentType });
		},

		updateImage(item){
			this.$Helper.get_local('socket_stream').on("stream_zone" + item.id, (msg)=>{
				if(this.objectURLs[item.id]){
					URL.revokeObjectURL(this.objectURLs[item.id]);
				}
				const blob = this.base64ToBlob(msg, 'image/jpeg');
				const objectURL = URL.createObjectURL(blob);
				this.objectURLs[item.id] = objectURL;

				let img = document.getElementById("img_zone"+item.id);
				if (img) {
					img.src = objectURL;
				}
			})
		},

		initialize () {
			this.desserts = this.list;
			this.desserts.forEach(item => {
				this.updateImage(item);
			});
			this.close()
		},

	}, // methods

	mounted(){
		//this.render_devices(null);
		// console.log('****************************************** created', this.info_to_constellation);
		// set id document
		let dw = this;
		// container
		let content 		= document.getElementById('content' + this.ref_draw);
		// this.content_draw 	= content;
		// image background
		let img 			= document.getElementById('image' + this.ref_draw);
		// canvas
		let board 			= document.getElementById('draw' + this.ref_draw);						


		let current_width, current_height;

		let board_context;

		if (board.getContext("2d")) {


				// board_context.beginPath();


			this.$nextTick(() =>{
				// window.devicePixelRatio=1;
				// let scale = window.devicePixelRatio;
				current_width	=	board.width  = /*Math.floor(*/img.getBoundingClientRect().width /** scale)*/;
				current_height 	=	board.height = /*Math.floor(*/img.getBoundingClientRect().height /** scale)*/;
				
				board_context 	= board.getContext("2d");
				this.context_draw 	= board_context;
				
				this.shape_draw 	= {
					w : current_width,
					h : current_height 
				};        

				// this.onResize();
				if (this.info_to_constellation) {
					// console.log('***************************  render constellation')
					const timer = setTimeout(()=>{
						this.selected_constellation(this.info_to_constellation);
						clearTimeout(timer)
					}, 500)
				}
			})
				

			function draw_point(loc){
				if (dw.is_edit) {

					let location = new Image();

					location.src = dw.$EXT + '/img/location.png'
					location.position = 'absolute';

					// console.log('draw_point')

					location.onload = function(){					
					    board_context.drawImage(location,loc.x,loc.y, 10,10);  
					    //console.log(location, 'img')
					}
				}

			}
		}else{
			console.log('No Support canvas context')
		}
		// click
		board.addEventListener('click', function(event){
			// console.log('mousedown');
			let pos = getMousePos(board, event);
			dw.send_action_icon(pos);
		}, false)

		function getMousePos(canvas, evt) {
		    let rect = canvas.getBoundingClientRect();
		    // console.log(rect, 'rect')
		    return {
		        x: parseInt((evt.clientX - rect.left) / (rect.right - rect.left) * canvas.width),
		        y: parseInt((evt.clientY - rect.top) / (rect.bottom - rect.top) * canvas.height)		        
	    	};
		} // getMousePos

	
		let list_coords = this.coordinates;
		let search 		= null;
		let type 		= 'warning';
		
		
		
		
	}, // mounted

	beforeDestroy(){
		if (this.drawer) {
			this.drawer.close_connection();
		}
		if (this.streamingObjectURL) {
			URL.revokeObjectURL(this.streamingObjectURL);
		}
		Object.values(this.objectURLs).forEach(url => URL.revokeObjectURL(url));
	}, // beforeDestroy

};